import * as React from "react";

const ReportsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M4 6.25C4 5.00736 5.00736 4 6.25 4H14.75C15.9926 4 17 5.00736 17 6.25V14H20.5V17.25C20.5 19.0449 19.0449 20.5 17.25 20.5H7.25C5.45507 20.5 4 19.0449 4 17.25V6.25ZM17 15.5V19H17.25C18.2165 19 19 18.2165 19 17.25V15.5H17ZM15.5 19V6.25C15.5 5.83579 15.1642 5.5 14.75 5.5H6.25C5.83579 5.5 5.5 5.83579 5.5 6.25V17.25C5.5 18.2165 6.2835 19 7.25 19H15.5Z"
      fill={props.color ? props.color : "black"}
    />
    <path
      d="M7.00001 8.75C7.00001 8.33579 7.3358 8 7.75001 8H13.25C13.6642 8 14 8.33579 14 8.75C14 9.16422 13.6642 9.5 13.25 9.5H7.75001C7.3358 9.5 7.00001 9.16422 7.00001 8.75ZM7.00001 12.25C7.00001 11.8358 7.3358 11.5 7.75001 11.5H13.25C13.6642 11.5 14 11.8358 14 12.25C14 12.6642 13.6642 13 13.25 13H7.75001C7.3358 13 7.00001 12.6642 7.00001 12.25ZM7.00001 15.75C7.00001 15.3358 7.3358 15 7.75001 15H10.25C10.6642 15 11 15.3358 11 15.75C11 16.1642 10.6642 16.5 10.25 16.5H7.75001C7.3358 16.5 7.00001 16.1642 7.00001 15.75Z"
      fill={props.color ? props.color : "black"}
    />
  </svg>
);

export default ReportsIcon;